<template>
<otif-modal :value="value" @input="$emit('input', $event)" @shown="onShown"
    title="Edit User">
        <otif-textInput
            ref="firstInput"
            v-model="$v.username.$model"
            label="Username"
            :disabled="editing"
            required
            :validation="$v.username"
            invalidMessage="Username is required"/>
        <otif-checkbox
            v-model="role"
            label="Administrator"/>
        <otif-passwordInput
            v-model="$v.password.$model"
            :label="(editing)? 'Change Password' : 'Password'"
            :validation="$v.password"
            invalidMessage="Passwords must match"/>
        <otif-passwordInput
            v-model="$v.password2.$model"
            label="Re-type Password"
            :validation="$v.password2"
            invalidMessage="Passwords must match"/>
        <template slot="footer">
            <otif-button className="secondary" @click.native="cancel">Cancel</otif-button>
            <otif-button className="primary" @click.native="save" :disabled="$v.$invalid">Save</otif-button>
        </template>
</otif-modal>
</template>

<script>

import UserResource from '@/models/user.js';
import { validationMixin } from 'vuelidate';
import { required, sameAs } from 'vuelidate/lib/validators';

export default {

    props: ['value', 'editUser'],
    mixins: [ validationMixin ],
    data() {
        return {
            username: '',
            password: '',
            password2: '',
            role: false
        }
    },

    computed: {
        editing() {
            return !(!this.editUser);
        }
    },

    validations: {
        username: {
            required
        },
        password: {
            required
        },
        password2: {
            required,
            sameAsPasword: sameAs('password')
        }
    },

    methods: {
        cancel() {
            this.$emit('input', false);
        },

        save() {
            var userResource;
            if (this.editUser) {
                userResource = this.editUser;
            } else {
                userResource = new UserResource();
            }

            userResource.set('user_name', this.username);

            if (userResource.isNew() || this.password !== '')
            {
                userResource.set('password', this.password);
            }
            userResource.set('role', this.role === true ? 'Administrator' : 'User');
            userResource.save()
            .then(() => {
                this.$snotify.clear();
                this.$snotify.info('User Saved');
                this.$v.$reset();
                this.$emit('saved');
                this.$emit('input', false);
            })
            .catch((err) => {
                this.$snotify.clear();

                if (err.response.status === 409) {
                    this.$snotify.error('Username already exists.');
                } else {
                    this.$snotify.error('There was an error saving the user.');
                }
            });

        },
        onShown() {
            if (this.editUser) {
                this.username = this.editUser.get('user_name');
                this.role = this.editUser.get('role') === 'Administrator';
                this.password = '';
                this.password2 = '';
            } else {
                this.username = '';
                this.role = false;
                this.password = '';
                this.password2 = '';
            }
            this.$refs['firstInput'].focus();
        }
    }
}

</script>
